import React from 'react';
import { MdOutlineSearch } from 'react-icons/md';

type SearchInputProps = {
  onSearchChange: (event) => void;
  search: string;
  placeholder?: string;
};

const SearchInput: React.FC<SearchInputProps> = ({
  search,
  onSearchChange,
  placeholder = 'Search'
}) => {
  const onSearch = (event) => {
    onSearchChange(event.target.value);
  };

  return (
    <div className="relative shrink-0 flex h-12 border-1 border-gray-300 rounded-full">
      <MdOutlineSearch
        className="absolute left-3 text-gray-400 self-center justify-center"
        size={24}
      />
      <input
        type="text"
        className="w-full h-full px-11 rounded-full text-base text-gray-600 placeholder:text-gray-400"
        placeholder={placeholder}
        value={search}
        onChange={onSearch}
      />
    </div>
  );
};

export default SearchInput;
